import styled, { css } from 'styled-components';

import { TinyDropDownOption } from '..';

export const Anchor = styled.a<Pick<TinyDropDownOption, 'disabled' | 'selected'>>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 10px 15px;
  color: ${({ theme }) => theme.colors.black100};
  font-size: ${({ theme }) => theme.fontSize.B3};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.black100};
    background-color: rgba(204, 204, 204, 0.15);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: inherit;
      color: ${({ theme }) => theme.colors.gray600};

      &:hover,
      &:focus {
        color: ${({ theme }) => theme.colors.gray600};
        background-color: ${({ theme }) => theme.colors.white100};
      }
    `}
`;
